export default function() {
    return <div>Something went wrong!!</div>
}